import { AppType } from "client/Api/Apps/common";
import { ReactElement } from "react";
import { useRenderManager } from "../../useRenderManager";
import { RssLiveInformationProvider } from "client_legacy/Workspace/LiveInformation/Rss/provider";
import { RssLiveTileContent } from "./RssLiveTileContent";
import { TileRenderState } from "../../RenderState/common";
import { TileContextProvider } from "../../TileContextProvider";
import { Coordinate } from "client/Misc/commonTypes";

export type RssTileContentProps = {
	renderState: TileRenderState<AppType.Rss>;
	onEdit: (() => void) | undefined;
	onOpenTileMenu: (coordinate: Coordinate) => void;
	provider: RssLiveInformationProvider;
};

export const RssTileContent = (props: RssTileContentProps): ReactElement => {
	const {
		renderState,
		onEdit,
		onOpenTileMenu,
		provider
	} = props;

	const {
		dimension,
		data: { settings }
	} = renderState;

	const tileContent: ReactElement = useRenderManager(
		dimension,
		() => (
			<RssLiveTileContent
				provider={provider}
				tabs={settings.tabs}
				onEdit={onEdit}
				onOpenTileMenu={onOpenTileMenu}
			/>
		)
	);

	return (
		<TileContextProvider
			renderState={renderState}
		>
			{tileContent}
		</TileContextProvider>
	);
};
RssTileContent.displayName = "RssTileContent";
